import AOS from 'aos';

window.addEventListener('load', () => {
    setTimeout(() => {
        AOS.init({
            once: true,
            offset: 100,
            duration: 700,
            delay: 300
        });
    }, 401);
});

$(function() {
    let $lists = document.querySelectorAll('.js-anim-line');

    function animateLine($list, translateX) {
        let totalWidth = 0;
        const $items = $list.querySelectorAll('.js-anim-el');
        $items.forEach(function(childElement) {
            totalWidth += childElement.offsetWidth;
        });

        $list.style.transform = `translate3d(${-translateX}px, 0, 0)`;
        $list.style.willChange = 'transform';

        translateX += 1;

        if (translateX <= totalWidth / 2) {
            requestAnimationFrame(() => animateLine($list, translateX));
        } else {
            $list.style.transform = 'translate3d(0, 0, 0)';
            translateX = 0;
            requestAnimationFrame(() => animateLine($list, translateX));
        }
    }

    if ($lists.length > 0) {
        $lists.forEach($list => {
            animateLine($list, 0);
        });
    }

    // hovered-links-content block
    const isMobileDevice = window.navigator.userAgent.toLowerCase().includes('mobi');

    $('.hovered-links-content__item-desc').hide();
    $('.hovered-links-content__item').each(function() {
        let $item = $(this);
        if ($item.hasClass('link') && isMobileDevice) {
            return;
        }

        $item.on('mouseenter touchstart', function () {
            $(this).find('.hovered-links-content__item-desc').stop().slideDown(500);
        });

        $item.on('mouseleave touchend', function () {
            $(this).find('.hovered-links-content__item-desc').stop().slideUp(500);
        });
    });

    $('.hovered-simple-links__item-desc').hide();
    $('.hovered-simple-links__item').each(function() {
        let $item = $(this);

        $item.on('mouseenter touchstart', function () {
            $(this).find('.hovered-simple-links__item-desc').stop().slideDown(500);
        });

        $item.on('mouseleave touchend', function () {
            $(this).find('.hovered-simple-links__item-desc').stop().slideUp(500);
        });
    });
});